export const Keys = {
  // Measure

  Facade: {
    Variable: 'facade',
    Values: {
      Putz: {
        key: 'putz',
        forbidden: null,
      },
      Klinker: {
        key: 'klinker',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
    },
  },

  HouseRotate: {
    Variable: 'housRotate',
    Attribute: {
      Grad: {
        key: 'grad',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
    },
  },

  // Colors
  ProfilColor: {
    Variable: 'color',
    MaxValues: {
      'veranda-free': 2,
      'veranda-basic': 2,
      'veranda-pro': -1,
      'veranda-enterprise': -1,
      free: 2,
      basic: 2,
      pro: -1,
      enterprise: -1,
    },
  },

  // Roof
  Eindeckung: {
    Variable: 'glassDensity',
    Values: {
      Glas: {
        key: 'glas',
        forbidden: null,
      },
      Polycarbonat: {
        key: 'poly',
        forbidden: null,
      },
      Lamelle: {
        key: 'lamelle',
        forbidden: [
          'veranda-free',
          'veranda-basic',
          'free',
          'basic',
          'veranda-pro',
          'pro',
        ],
      },
      Solar: {
        key: 'solar',
        forbidden: [
          'veranda-free',
          'veranda-basic',
          'veranda-pro',
          'free',
          'basic',
          'pro',
        ],
      },
      Welle: {
        key: 'welle',
        forbidden: [
          'veranda-free',
          'veranda-basic',
          'veranda-pro',
          'free',
          'basic',
          'pro',
        ],
      },
      Trapez: {
        key: 'trapez',
        forbidden: [
          'veranda-free',
          'veranda-basic',
          'veranda-pro',
          'free',
          'basic',
          'pro',
        ],
      },
    },
    Attributes: {
      Opacity: 'opacity',
      Roughness: 'roughness',
      Depth: 'depth',
      Glas: 'glas',
      Frequenz: 'frequenz',
      Amplitude: 'amplitude',
    },
  },

  // Marquee

  Markise: {
    Variable: 'marquee',
    Values: {
      Unterdach: {
        key: 'unterdach',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Aufdach: {
        key: 'aufdach',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Plissee: {
        key: 'plissee',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Stoff: {
        key: 'stoff',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      IntegrierteBox: {
        key: 'integrierteBox',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Ohne: { key: 'ohne', forbidden: null },
    },
  },

  Depth: {
    Variable: 'depth',
  },
  Width: {
    Variable: 'width',
  },
  Height: {
    Variable: 'height',
  },
  Angle: {
    Vatiable: 'angle',
  },
  FrontHeight: {
    Variable: 'frontHeight',
  },

  EavesWidth: {
    Variable: 'eaves',
  },

  Eaves: {
    Variable: 'dachvorsprung',
  },

  DynamicLog: {
    Variable: 'dynamicLog',
    Values: {
      Ja: {
        key: 'ja',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Nein: {
        key: 'nein',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
    },
  },

  // Seitenwände
  SeitenwandTyp: {
    Variable: 'seitenwandTyp',
    Values: {
      Ohne: {
        key: '$noSelection',
        forbidden: null,
      },
      Keil: {
        key: 'keil',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Rahmenwand: {
        key: 'rahmenwand',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Schiebetuer: {
        key: 'schiebetuer',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Plankenwand: {
        key: 'plankenwand',
        forbidden: [
          'veranda-free',
          'veranda-basic',
          'veranda-pro',
          'free',
          'basic',
          'pro',
        ],
      },
      Senkrechtmarkise: {
        key: 'senkrechtmarkise',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      RahmenSchiebetuer: {
        key: 'rahmenSchiebetuer',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      Shutters: {
        key: 'shutters',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
    },
  },

  ZusatzKeil: {
    Variable: 'zusatzKeil',
    Values: {
      Ja: { key: 'ja', forbidden: ['veranda-free', 'veranda-basic'] },
      Nein: { key: 'nein', forbidden: null },
    },
  },

  Seitenwände: {
    Variable: 'seitenwaende',
    Values: {
      SeitenwandLinks: {
        key: 'seitenwandLinks',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      SeitenwandRechts: {
        key: 'seitenwandRechts',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      SeitenwandMittig: {
        key: 'seitenwandMittig',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
      SeitenwandHinten: {
        key: 'wandHinten',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
    },
  } as const,

  RahmenwandTyp: {
    Variable: 'rahmenwand',
    Values: {
      Wand1: 'typ1',
      Wand2: 'typ2',
    },
  },

  GlasAuswahlKeil: {
    Variable: 'glasWedge',
    Values: {
      Klar: 'klar',
      Opal: 'opal',
    },
  },

  VerticalMarquee: {
    Variable: 'verticalMarqueeTyp',
    Values: {
      Eckig: 'eckig',
      Rund: 'rund',
      Ohne: 'ohne',
    },
    Attributes: {
      Position: 'position',
      Height: 'height',
      Width: 'width',
    },
  },

  GlasAuswahlUnten: {
    Variable: 'glasunten',
    Values: {
      Klar: 'klar',
      Opal: 'opal',
    },
  },

  GlasAuswahlOben: {
    Variable: 'glasoben',
    Values: {
      Klar: 'klar',
      Opal: 'opal',
    },
  },

  RahmenHoehe: {
    Variable: 'rahmenhoehe1',
  },

  BürstenTyp: {
    Variable: 'buerstentyp',
  },

  PlankenwandHeheTyp: {
    Variable: 'plankHeigTyp',
    Values: {
      full: 'full',
      default: 'default',
      individuell: 'individuell',
    },
  },

  PlankenwandHoehe: {
    Variable: 'plankenwandhoehe',
    Attributes: {
      Variable: 'plankenhoehe',
    },
  },

  PlankenwandObenTyp: {
    Variable: 'plankenwandtyp',
    Values: {
      Seitenwand: 'seitenwand',
      RahmenTyp1: 'typ1',
      RahmenTyp2: 'typ2',
    },
  },

  PlankHeight: {
    Left: 'plankHeightLeft',
    LeftAttr: 'plankHeightLeftAttr',
    Right: 'plankHeightRight',
    Center: 'plankHeightCenter',
    CenterAttr: 'plankHeightCenterAttr',
    CenterLeft: 'plankHeightCenterLeft',
    CenterRight: 'plankHeightCenterRight',
  },

  // Veranda-Typen Grunddaten

  Modell: {
    Variable: 'typ',
    Values: {
      Veranda: {
        key: 'veranda',
        forbidden: null,
      },
      Qubus: {
        key: 'qubus',
        forbidden: [
          'veranda-free',
          'veranda-basic',
          'veranda-pro',
          'free',
          'basic',
          'pro',
        ],
      },
    },
    Attributes: {
      Log: 'log',
      Bar: 'bar',
      AttachedBar: 'attachedBar',
      RoofBar: 'roofBar',
      CoverStrips: 'coverStrips',
    },
    Attribute: {
      Place: {
        key: 'place',
        forbidden: ['veranda-free', 'veranda-basic', 'free', 'basic'],
      },
    },
    MaxValues: {
      'veranda-free': 1,
      'veranda-basic': 1,
      'veranda-pro': 2,
      'veranda-enterprise': -1,
      free: 1,
      basic: 1,
      pro: 2,
      enterprise: -1,
    },
  },

  // Seitenwand Grunddaten

  Sidewall: {
    Variable: 'seitenwandTyp',
    Attributes: {
      Log: 'rahmen',
      Glas: 'glas',
      MaxHeight: 'maxHeight',
      AttachedBar: 'attachedBar',
      RoofBar: 'roofBar',
    },
  },

  // Veranda-Pfosten

  Logs: {
    Variable: 'pfostenart',
  },
} as const
